"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSuggestionResultType = void 0;
var GetSuggestionResultType;
(function (GetSuggestionResultType) {
    GetSuggestionResultType[GetSuggestionResultType["Property"] = 1] = "Property";
    GetSuggestionResultType[GetSuggestionResultType["Building"] = 2] = "Building";
    GetSuggestionResultType[GetSuggestionResultType["Address"] = 3] = "Address";
    GetSuggestionResultType[GetSuggestionResultType["District"] = 4] = "District";
    GetSuggestionResultType[GetSuggestionResultType["Area"] = 5] = "Area";
    GetSuggestionResultType[GetSuggestionResultType["Estate"] = 6] = "Estate";
    GetSuggestionResultType[GetSuggestionResultType["Phase"] = 7] = "Phase";
    GetSuggestionResultType[GetSuggestionResultType["Block"] = 8] = "Block";
    GetSuggestionResultType[GetSuggestionResultType["SpecialDistrict"] = 99] = "SpecialDistrict";
    GetSuggestionResultType[GetSuggestionResultType["Keyword"] = -1] = "Keyword";
})(GetSuggestionResultType = exports.GetSuggestionResultType || (exports.GetSuggestionResultType = {}));
